import ClosestInteger from 'utils/ClosestInteger'
import Constants from 'utils/Constants'
import { deleteCookie, getCookie, setCookie } from 'utils/Cookies'
import { formatTime } from 'utils/FormatDateTime'
import GetBreakpoint from 'utils/GetBreakpoint'
import GetViewportSize from 'utils/GetViewportSize'
import History from 'utils/History'
import { param, deparam } from 'utils/Param'
import LoadScript from 'utils/LoadScript'
import { formatAvailability, formatSlotsToDays } from 'utils/FormatAvailability'
import { formatOpenOrClosed } from 'utils/OpenOrClosed'
import { Browser } from 'utils/Browser'
import { capitalize, titleCase } from 'utils/Strings'

class Utils {
	constructor() {
		this.capitalize = capitalize
		this.closestInteger = ClosestInteger
		this.constants = Constants
		this.deleteCookie = deleteCookie
		this.deparam = deparam
		this.formatAvailability = formatAvailability
		this.formatSlotsToDays = formatSlotsToDays
		this.formatTime = formatTime
		this.getBreakpoint = GetBreakpoint
		this.getViewportSize = GetViewportSize
		this.getCookie = getCookie
		this.history = History
		this.loadScript = LoadScript
		this.formatOpenOrClosed = formatOpenOrClosed
		this.param = param
		this.setCookie = setCookie
		this.titleCase = titleCase
		this.browser = new Browser()
	}

	name() {
		return 'Utils'
	}
}

export default Utils
